import React from 'react';
import {
  GridSkeleton,
  ListSkeleton,
  ListSkeletonContent,
  ListSkeletonLine,
  ListSkeletonMedia,
  ListSkeletonRow,
} from './InfluencersListSkeleton.styles';

const InfluencersListSkeleton = ({ gridView }) => {
  return Array.from({ length: 8 }).map((_, index) => {
    if (gridView) {
      return <GridSkeleton key={index} $animationTime={6} />;
    }

    return (
      <ListSkeleton key={index}>
        <ListSkeletonMedia $animationTime={6} />
        <ListSkeletonContent>
          <ListSkeletonLine $animationTime={6} $height="2rem" $width="56%" />
          <ListSkeletonRow>
            <ListSkeletonLine $animationTime={6} $height="1.4rem" $width="42%" />
            <ListSkeletonLine $animationTime={6} $height="1.4rem" $width="28%" />
          </ListSkeletonRow>
        </ListSkeletonContent>
      </ListSkeleton>
    );
  });
};

export default InfluencersListSkeleton;
